import React, { useState } from 'react'
import { useTranslation } from '../../locale/useTranslation'
import BackRoundButton from '../../framework/forms/helpercomponents/buttons/BackRoundButton';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { Loader } from '../../framework/forms/helpercomponents/Loader';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api"
import { useNavigate } from 'react-router-dom';
import { LocalDateTimeColumn } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { ENTITYNAME, FILEURL, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import ToastNotification from '../../components/ToastNotification';

const ScheduleExportHistoryEditForm = () => {
  const lang = useTranslation();
  const navigate = useNavigate();

  const defaultDates = utility.getFirstAndLastDateOfMonth();

  const blankDataItem = {
    StartDate: defaultDates.FirstDate,
    EndDate: defaultDates.LastDate,
  };

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [gridData, setGridData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    if (!dataItem.StartDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_start_date_error_message });
      return false;
    }
    if (!dataItem.EndDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_end_date_error_message });
      return false;
    }
    if (dataItem.StartDate > dataItem.EndDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.end_date_should_be_greater_than_start_date_error_message });
      return false;
    }
    return true;
  };

  const loadData = async () => {
    if (!isValid()) return;

    setIsLoading(true);

    let payload = {
      StartDate: dataItem?.StartDate ? utility.convertStringDatetoMilliseconds(dataItem?.StartDate) : null,
      EndDate: dataItem?.EndDate ? utility.convertStringDatetoMilliseconds(dataItem?.EndDate) : null,
    };

    const res = await API.getScheduleExportHisory(payload);
    if (res.success) {
      setGridData(res.data.length > 0 ? res.data : []);
    } else {
      setGridData([]);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    setIsLoading(false);
  };

  const downloadExcel = async () => {
    if (gridData.length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_record_found_error_message });
      return;
    }

    let storeData = gridData.map((item) => ({
      FileName: item?.FileName,
      Date: utility.convertMilisecondsToDateTimeString(item?.addOn),
      User: item?.addBy.name
    }));

    let res = await API.exportCSV(storeData);
    if (res.success) {
      window.open(FILEURL().BASEURL + "downloadReport/" + res.data);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };
  const FileDownloadCell = (props) => {

    const [hover, setHover] = useState(false);

    const field = props.field || "";
    const value = props.dataItem[field];

    const downloadFile = () => {
      window.open(FILEURL().BASEURL + 'downloadReport/' + value)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
    }

    return <td>
      <div
        style={{ color: hover ? 'blue' : "black", cursor: 'pointer' }}
        onClick={downloadFile}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {props.dataItem[field]}
      </div>
    </td>;
  };

  const deleteExportFile = async (dataItem) => {
    let res = await API.deleteData(ENTITYNAME.SchedulExportHistory, dataItem.SID);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }
    setGridData(gridData.filter((item) => item.SID !== dataItem.SID));
  }

  const MenuCommandCell = (props) => (
    <div className="" style={{ padding: "1.5px" }}>
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteExportFile(props.dataItem), () => { })} />
    </div>
  )

  return (
    <div>
      <h1 className="page-title txt-color-bludeDark">
        <i className="fa fa-table marlr" style={{ fontSize: "20px", color: "GrayText" }}></i>
        <span>{lang.schedule_export_history_header}</span>
      </h1>

      <div className="flex-container">
        <div className="martb mar">
          <BackRoundButton onClick={() => navigate(-1)} />
        </div>

        <div className="flex-container-reverse flex-item-auto mb-2 mr-2">
          <div className="m-1" style={{ paddingTop: "12px" }}>
            <RoundButton
              icon="download"
              btnColor="warning"
              style={{ margin: "0px 03px" }}
              title={lang.download_button_tooltip}
              onClick={downloadExcel}
            />
          </div>
          <div className="mt-1" style={{ paddingTop: "12px" }}>
            <ActionButton title={lang.show_button_tooltip} name={lang.show_button_text} onClick={loadData} />
          </div>
          <div className="ml-3 mr-2" style={{ marginTop: "-7px", width: "16%" }}>
            <label className="form-label">{lang.to_date_label} *</label>
            <input type="date" className="form-control form-control-sm" name="EndDate" value={dataItem.EndDate} onChange={onChange} />
          </div>
          <div className="ml-2" style={{ marginTop: "-7px", width: "16%" }}>
            <label className="form-label">{lang.from_date_label} *</label>
            <input type="date" className="form-control form-control-sm" name="StartDate" value={dataItem.StartDate} onChange={onChange} />
          </div>
        </div>
      </div>

      {isLoading && <Loader />}
      {!isLoading && (
        <Grid data={gridData} style={{ height: "70vh" }} resizable={true}>
          {/* <GridColumn field="ScheduleFilter.query.startDate" title={lang.start_date_column} cell={LocalDateTimeColumn} />
            <GridColumn field="ScheduleFilter.query.endDate" title={lang.end_date_column} cell={LocalDateTimeColumn} />
            <GridColumn field="Schedule" title={lang.schedule_column} /> */}
          <GridColumn cell={MenuCommandCell} width={"35px"} locked={true} />
          <GridColumn field="FileName" title={lang.file_name_column} width="700px" cell={FileDownloadCell} />
          <GridColumn field="addOn" title={lang.date_column} cell={LocalDateTimeColumn} />
          <GridColumn field="addBy.name" title={lang.user_column} />
        </Grid>
      )}
    </div>
  );
};

export default ScheduleExportHistoryEditForm